import { render, staticRenderFns } from "./Collections.vue?vue&type=template&id=0cec551a&scoped=true&"
import script from "./Collections.vue?vue&type=script&lang=js&"
export * from "./Collections.vue?vue&type=script&lang=js&"
import style0 from "./Collections.vue?vue&type=style&index=0&id=0cec551a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec551a",
  null
  
)

export default component.exports